import {Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import socket, {IResponse} from '@sockets';
import IChannel from '../network/IChannel';
import NewsChannelItem from './NewsChannelItem';

export default function NewsChannel() {
	const {t} = useTranslation();
	const [channels, setChannels] = useState<IChannel[]>([]);
	
	useEffect(() => {
		socket.emit('network:news_channels', null, (data: IResponse<IChannel[]>) => {
			if (data.success) {
				setChannels(data.result);
			}
		});
	}, []);
	
	
	return (
		<div className="flex flex-col space-y-3 mx-4">
			{
				channels.length > 0 ?
					<>
						<div className="flex flex-row justify-between">
							<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'primary.50'}}
							            className="font-medium">{t('news_channel')}</Typography>
						</div>
						{
							channels.map(channel => <NewsChannelItem key={channel.id} channel={channel}/>)
						}
					</>
					:
					<></>
			}
		</div>
	);
}
